/**
 * WalletConnect expects absolute RPC URLs when the dApp uses same-origin paths
 * like `/api/rpc/ethereum` (Charge & Strike: `normalizeWalletConnectRpcMap`).
 */
import { getRpc } from '../connectors/utils'

export function normalizeRpcMapForWalletConnect(
  raw: Record<number, string | string[]>,
  origin: string,
): Record<number, string> {
  const out: Record<number, string> = {}
  for (const key of Object.keys(raw)) {
    const chainId = Number(key)
    const v = raw[chainId]
    const url = Array.isArray(v) ? v[0] : v
    if (!url) continue
    out[chainId] = url.startsWith('/') && origin ? new URL(url, origin).href : url
  }
  return out
}

export function getWalletConnectRpcNormalized(): Record<number, string> {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  return normalizeRpcMapForWalletConnect(getRpc(), origin)
}
